// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"11a20a5a","703":"cdb4c1fb","787":"19922724"}[chunkId] + ".chunk.js";
};